export const GET_OFFERS_QUERY = `
  query GetOffers($where: offers_bool_exp, $order_by: [offers_order_by!] = [{ created_at: desc }], $limit: Int, $offset: Int) {
    offers(where: $where, order_by: $order_by, limit: $limit, offset: $offset) {
      id
      company_id
      firm_id
      firm_short_name
      firm_established
      proposal_given
      contract_subject_id
      scope_of_work_id
      proposal_date
      proposal_file_key
      proposal_file_size
      revised_proposal_given
      revised_proposals
      proposal_status_id
      comment
      reminder_date
      reminder_note
      sector_id
      created_by
      created_at
      updated_at
      user {
        id
        first_name
        last_name
      }
      contract_subject {
        id
        name
      }
      scope_of_work {
        id
        name
      }
      company {
        id
        name
      }
      firm {
        id
        firm_name
        firm_short_name
      }
      proposal_status {
        id
        name
      }
    }
    offers_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_OFFER_BY_ID_QUERY = `
  query GetOfferById($id: Int!) {
    offers_by_pk(id: $id) {
      id
      company_id
      firm_id
      firm_short_name
      firm_established
      proposal_given
      contract_subject_id
      scope_of_work_id
      proposal_date
      proposal_file_key
      proposal_file_size
      revised_proposal_given
      revised_proposals
      proposal_status_id
      comment
      reminder_date
      reminder_note
      sector_id
      created_by
      created_at
      updated_at
      user {
        id
        first_name
        last_name
      }
      contract_subject {
        id
        name
      }
      scope_of_work {
        id
        name
      }
      company {
        id
        name
      }
      firm {
        id
        firm_name
        firm_short_name
      }
      proposal_status {
        id
        name
      }
    }
  }
`; 